import {
  ActionType,
  AppContextType,
  DrugCoverageFilterOption,
  PlanSNPType,
} from "../../../@types";
import { SearchFilterKeys } from "./constants";

export const updateFilter = (
  { state, dispatch }: AppContextType,
  filterName: SearchFilterKeys,
  value: string | string[] | DrugCoverageFilterOption | boolean | undefined
): void => {
  dispatch({
    type: ActionType.UPDATE_SEARCH_RESULTS_FILTERS,
    payload: {
      ...state.searchResultsFilters,
      [filterName]: value,
    },
  });
};

export const updateSNPFilters = (
  { dispatch }: AppContextType,
  snpTypes: string[] | PlanSNPType[]
): void => {
  const hasNotSnp = snpTypes.includes(PlanSNPType.SNP_TYPE_NOT_SNP);
  if (snpTypes.length && !hasNotSnp) {
    // the snp filters are additive, so if any exist, we need to also send SNP_TYPE_NOT_SNP to the API
    snpTypes.push(PlanSNPType.SNP_TYPE_NOT_SNP);
  } else if (snpTypes.length === 1 && hasNotSnp) {
    snpTypes = [];
  }
  dispatch({
    type: ActionType.UPDATE_SNP_FILTERS,
    payload: snpTypes,
  });
};
